<section class="not-found">
  <div class="not-found__content">
    <p class="not-found__code">404</p>
    <h1 class="not-found__title">Esta página no existe</h1>
    <p class="not-found__text">
      La página que buscas no existe o fue movida a una nueva dirección.
    </p>
    <a routerLink="/" class="not-found__btn">Ir al inicio</a>
  </div>
</section>
